/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  uat: false,
  production: true,
  maintenanceMode: false,
  SSO_REDIRECT_URL: 'https://secureaccess.uat.nam.citigroup.net/idp/startSSO.ping?PartnerSpId=GPA-166612-livewelladmin&TargetResource=http%3A%2F%2Fuat.admin.livewellatciti.com%2Fapi%2Fsso',
  SSO_LOGOUT_REDIRECT_URL: 'https://secureaccessweb.uat.nam.citigroup.net/siteminderagent/forms/logout.html',
  prodOldSSO: false,
  viewUserCreatedData: true,
  documentUploadSuperAdminOnly: true,
  cookieDomain: '.livewellatciti.com',
  sessionTimeout: 20,
  domain: 'https://uat.livewellatciti.com'
};
